import { useMemo } from 'react';
import { HookhouseFormData } from '@/types';
import { useVocalConfig } from '@context/VocalConfigContext';
import { useProductionConfig } from '@context/ProductionConfigContext';
import { useSoloChoreographer } from '@features/SoloChoreographer';
import { useRiffDna } from '@context/RiffDnaContext';
import { useStudioForm } from '@context/StudioFormContext';
import { assemblePromptPreview, PromptPreviewData } from '@utils/promptAssembler';
import { buildNarrativeBlock } from '@/hooks/useNarrativeEngine';
import type { PersonaOverride } from '@/types/persona.types';

export function usePromptPreview(formData: HookhouseFormData, personaOverride?: PersonaOverride | null): PromptPreviewData {
  const { getActiveVocalArchitecture } = useVocalConfig();
  const { getFullProductionArchitecture } = useProductionConfig();
  const { getSoloBlock, getSectionHeader, output: soloOutput } = useSoloChoreographer();
  const { getRiffDnaBlock, output: riffDnaOutput } = useRiffDna();
  const { narrativeBlueprint } = useStudioForm();

  return useMemo(() => {
    const vocalArch = getActiveVocalArchitecture();
    const prodArch = getFullProductionArchitecture();
    const riffDnaBlock = riffDnaOutput ? getRiffDnaBlock() : '';
    const soloBlock = soloOutput ? `${getSectionHeader()}\n${getSoloBlock()}` : '';
    const narrativeArch = narrativeBlueprint ? buildNarrativeBlock(narrativeBlueprint) : undefined;
    return assemblePromptPreview(formData, vocalArch || undefined, prodArch || undefined, riffDnaBlock || undefined, soloBlock || undefined, narrativeArch, personaOverride);
  }, [formData, getActiveVocalArchitecture, getFullProductionArchitecture, getRiffDnaBlock, riffDnaOutput, getSoloBlock, getSectionHeader, soloOutput, narrativeBlueprint, personaOverride]);
}
